import React from "react";
import SendIcon from "@mui/icons-material/Send";
import type { ButtonProps } from "@mui/material";
import { Button } from "@mui/material";

type LoadingSubmitButtonProps = ButtonProps & {
  isLoading?: boolean;
  isDisabled?: boolean;
  disableIcon?: boolean;
  label?: string;
  formName?: string;
};

export function LoadingSubmitButton(props: LoadingSubmitButtonProps) {
  const { isLoading, isDisabled, disableIcon, label, formName, ...rest } = props;
  return (
    <Button
      {...rest}
      color={rest.color || "primary"}
      type="submit"
      form={formName ? `form_${formName}` : undefined}
      endIcon={!disableIcon && <SendIcon />}
      loading={isLoading}
      disabled={isDisabled}
      loadingPosition="end"
      variant="contained"
    >
      {label || "Submit"}
    </Button>
  );
}
